<div class="modal-content modal-content-image-gallery">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{title | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="image-wrapper">
      <img [src]="imageData.url" class="img-fluid" />
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-end">
      <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">{{'Close' | translate}}</button>
    </div>
  </div>
</div>

